/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function showToast(options, context) {
    var formatInput = function (_a) {
        var content = _a.content, _b = _a.duration, duration = _b === void 0 ? 2000 : _b;
        return ({
            content: content,
            timeInSeconds: duration / 1000, // Toast 的持续时间：菜鸟App以s为单位
        });
    };
    context.WVCall('CNHybridToast.showToast', options, { formatInput: formatInput });
}

export { showToast as default };
